module.exports = __webpack_public_path__ + "img/wallet_pc_04.5d04d207.png";